import {
  AVAILABILITY_ERROR_CODES,
  errorText,
  VOICE_ERROR_MESSAGES,
} from '../errorMessages'

/**
 * The code of a failed voice input: the server's error code, the name of the browser's
 * microphone error, or TRANSCRIBE_FAILED for anything else (the network, a gateway).
 */
export const voiceErrorCode = (error: any): string => {
  const code = error?.response?.data?.error?.code
  if (typeof code === 'string' && code) {
    return code
  }
  // Refused by the server's size limit before the request reached the assistant.
  if (error?.response?.status === 413) {
    return 'AI_VOICE_INVALID_AUDIO'
  }
  const name = error?.name
  if (
    !error?.response &&
    typeof name === 'string' &&
    Object.prototype.hasOwnProperty.call(VOICE_ERROR_MESSAGES, name)
  ) {
    return name
  }
  return 'TRANSCRIBE_FAILED'
}

/**
 * What the composer says for a failed voice input. The voice texts are its own; for the
 * assistant's other refusals (usage limits, not available) the server's words win, as for a
 * question (see errorText).
 */
export const voiceErrorText = (error: any): string => {
  const code = voiceErrorCode(error)
  if (Object.prototype.hasOwnProperty.call(VOICE_ERROR_MESSAGES, code)) {
    return VOICE_ERROR_MESSAGES[code]
  }
  return errorText(code, error?.response?.data?.error?.message)
}

/**
 * The refusal says voice input (or the assistant) is not available any more: the capabilities
 * are read again, so the microphone goes away when it was switched off.
 */
export const isVoiceUnavailableCode = (code: string) =>
  code === 'AI_VOICE_DISABLED' || AVAILABILITY_ERROR_CODES.has(code)
